module.exports = __webpack_public_path__ + "static/media/OgKvT1024267_sm1.e30e1854.png";